import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createSchedule, updateScheduleById, getScheduleById } from "../../../../../services/schedule.service";
import { TScheduleForm, scheduleSchema } from "./scheduleSchema";
import { FormContainer, FormInput, Treturn } from "@4uhub/lib4uhub";
import { scheduleItems } from "../schedule.mock";

interface IScheduleProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.schedule.";

export const Schedule = memo(({ id, onBackButton }: IScheduleProps) => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createSchedule
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateScheduleById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getScheduleById
  //   );

  const saveHandler = async (v: TScheduleForm) => {
    // save({
    //   ...v,
    // });
    return { data: {}, success: true };
  };

  const updateHandler = async (v: TScheduleForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TScheduleForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TScheduleForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      //   return { data, success };

      const data = scheduleItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const successHandle = () => {
    onBackButton();
  };

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TScheduleForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "schedule")}
      schema={scheduleSchema}
      subtitle={t(translationPath + "new_schedule")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={successHandle}
      isModalForm={true}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInput
              name="identifier"
              label={t(translationPath + "identifier")}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
